import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/login" className="flex items-center gap-2 text-slate-600 hover:text-slate-900">
              <ChevronLeft className="w-5 h-5" />
              <span>Back</span>
            </Link>
            <h1 className="text-xl font-bold text-[#00247D]" style={{ fontFamily: 'Barlow Condensed' }}>
              TERMS OF SERVICE
            </h1>
            <div className="w-20" />
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-sm border border-slate-200 p-8">
          <p className="text-sm text-slate-500 mb-8">Last updated: February 17, 2026</p>

          <div className="prose prose-slate max-w-none">
            <h2 className="text-2xl font-bold text-[#00247D] mb-4" style={{ fontFamily: 'Barlow Condensed' }}>1. ACCEPTANCE OF TERMS</h2>
            <p className="text-slate-600 mb-6">
              By accessing or using Schedule Guru ("Service"), operated by Anglin Sports Consultancy ("Company", "we", "us", or "our"), 
              you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our Service.
            </p>

            <h2 className="text-2xl font-bold text-[#00247D] mb-4" style={{ fontFamily: 'Barlow Condensed' }}>2. DESCRIPTION OF SERVICE</h2>
            <p className="text-slate-600 mb-6">
              Schedule Guru is a web-based tournament and league scheduling platform that allows users to create, manage, and export 
              sports schedules. The Service includes features for round-robin scheduling, elimination brackets, pool play, and various 
              export formats including PDF and Excel.
            </p>

            <h2 className="text-2xl font-bold text-[#00247D] mb-4" style={{ fontFamily: 'Barlow Condensed' }}>3. USER ACCOUNTS</h2>
            <p className="text-slate-600 mb-4">To access certain features of the Service, you must create an account. You agree to:</p>
            <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
              <li>Provide accurate, current, and complete information during registration</li>
              <li>Maintain and promptly update your account information</li>
              <li>Maintain the security and confidentiality of your login credentials</li>
              <li>Accept responsibility for all activities that occur under your account</li>
              <li>Notify us immediately of any unauthorized use of your account</li>
            </ul>

            <h2 className="text-2xl font-bold text-[#00247D] mb-4" style={{ fontFamily: 'Barlow Condensed' }}>4. SUBSCRIPTION PLANS AND PAYMENTS</h2>
            <p className="text-slate-600 mb-4">We offer the following subscription tiers:</p>
            <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
              <li><strong>Free Tier:</strong> Round robin scheduling up to 8 teams, basic PDF / Excel / iCal exports, and a public share URL</li>
              <li><strong>Pro Monthly:</strong> $24 USD/month — every bracket format, live multi-sport stat tracking, AI schedule &amp; box-score import, roster manager, analytics, branded exports, and priority support</li>
              <li><strong>Pro Annual:</strong> $199 USD/year (~$16.58 USD/mo) — all Pro features with a ~31% discount versus paying monthly</li>
            </ul>
            <p className="text-slate-600 mb-6">
              Subscriptions automatically renew unless cancelled before the renewal date. Existing subscribers who signed up on
              legacy pricing continue billing at the price they signed up at until they cancel. Refunds are handled on a
              case-by-case basis at our discretion. Prices are subject to change with 30 days notice.
            </p>

            <h2 className="text-2xl font-bold text-[#00247D] mb-4" style={{ fontFamily: 'Barlow Condensed' }}>5. ACCEPTABLE USE</h2>
            <p className="text-slate-600 mb-4">You agree not to:</p>
            <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
              <li>Use the Service for any unlawful purpose or in violation of any applicable laws</li>
              <li>Attempt to gain unauthorized access to any portion of the Service</li>
              <li>Interfere with or disrupt the Service or servers connected to the Service</li>
              <li>Use any automated means to access the Service without our express permission</li>
              <li>Transmit any viruses, malware, or other harmful code</li>
              <li>Impersonate any person or entity or misrepresent your affiliation</li>
            </ul>

            <h2 className="text-2xl font-bold text-[#00247D] mb-4" style={{ fontFamily: 'Barlow Condensed' }}>6. INTELLECTUAL PROPERTY</h2>
            <p className="text-slate-600 mb-6">
              The Service, including all content, features, and functionality, is owned by Anglin Sports Consultancy and is protected 
              by international copyright, trademark, and other intellectual property laws. You may not copy, modify, distribute, sell, 
              or lease any part of our Service without our express written permission.
            </p>

            <h2 className="text-2xl font-bold text-[#00247D] mb-4" style={{ fontFamily: 'Barlow Condensed' }}>7. USER CONTENT</h2>
            <p className="text-slate-600 mb-6">
              You retain ownership of any content you submit to the Service (team names, schedules, etc.). By submitting content, 
              you grant us a non-exclusive, worldwide, royalty-free license to use, store, and display your content solely for the 
              purpose of providing the Service to you.
            </p>

            <h2 className="text-2xl font-bold text-[#00247D] mb-4" style={{ fontFamily: 'Barlow Condensed' }}>8. DISCLAIMER OF WARRANTIES</h2>
            <p className="text-slate-600 mb-6">
              THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. 
              WE DO NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED, ERROR-FREE, OR SECURE. YOUR USE OF THE SERVICE IS AT YOUR 
              SOLE RISK.
            </p>

            <h2 className="text-2xl font-bold text-[#00247D] mb-4" style={{ fontFamily: 'Barlow Condensed' }}>9. LIMITATION OF LIABILITY</h2>
            <p className="text-slate-600 mb-6">
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, ANGLIN SPORTS CONSULTANCY SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, 
              SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, 
              OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES RESULTING FROM YOUR USE OF THE SERVICE.
            </p>

            <h2 className="text-2xl font-bold text-[#00247D] mb-4" style={{ fontFamily: 'Barlow Condensed' }}>10. INDEMNIFICATION</h2>
            <p className="text-slate-600 mb-6">
              You agree to indemnify, defend, and hold harmless Anglin Sports Consultancy and its officers, directors, employees, 
              and agents from any claims, liabilities, damages, losses, and expenses arising from your use of the Service or violation 
              of these Terms.
            </p>

            <h2 className="text-2xl font-bold text-[#00247D] mb-4" style={{ fontFamily: 'Barlow Condensed' }}>11. TERMINATION</h2>
            <p className="text-slate-600 mb-6">
              We may terminate or suspend your account and access to the Service immediately, without prior notice, for any reason, 
              including breach of these Terms. Upon termination, your right to use the Service will immediately cease.
            </p>

            <h2 className="text-2xl font-bold text-[#00247D] mb-4" style={{ fontFamily: 'Barlow Condensed' }}>12. GOVERNING LAW</h2>
            <p className="text-slate-600 mb-6">
              These Terms shall be governed by and construed in accordance with the laws of the Cayman Islands, without regard to 
              its conflict of law provisions. Any disputes arising from these Terms shall be resolved in the courts of the Cayman Islands.
            </p>

            <h2 className="text-2xl font-bold text-[#00247D] mb-4" style={{ fontFamily: 'Barlow Condensed' }}>13. CHANGES TO TERMS</h2>
            <p className="text-slate-600 mb-6">
              We reserve the right to modify these Terms at any time. We will notify users of any material changes by posting the 
              new Terms on this page and updating the "Last updated" date. Your continued use of the Service after such changes 
              constitutes acceptance of the new Terms.
            </p>

            <h2 className="text-2xl font-bold text-[#00247D] mb-4" style={{ fontFamily: 'Barlow Condensed' }}>14. CONTACT INFORMATION</h2>
            <p className="text-slate-600 mb-6">
              If you have any questions about these Terms, please contact us at:<br />
              <strong>Anglin Sports Consultancy</strong><br />
              Email: info@scheduleguru.ws<br />
              Cayman Islands
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
